import { FirefinchUserStoryDto } from '../../../../api/models';
import { CostEstimateData } from '../components/CostEstimateForm';

export const createDefaultCostEstimateData = (
    serviceNames?: string[],
    userStories?: FirefinchUserStoryDto[]
): CostEstimateData => {
    const productiveServices = serviceNames ?? [];

    // Extract unique phase names from user stories
    let phases = [
        'Discovery',
        'Design',
        'Development',
        'Testing',
        'Deployment'
    ]; // Default phases

    if (userStories && userStories.length > 0) {
        const userStoryPhases = userStories
            .map(story => story.phase?.name)
            .filter((phase): phase is string => Boolean(phase))
            .filter((phase, index, arr) => arr.indexOf(phase) === index) // unique values
            .sort();

        if (userStoryPhases.length > 0) {
            phases = userStoryPhases;
        }
    }

    return {
        services: productiveServices,
        phases,
        estimates: {},
        phaseDurations: {},
        mvpFilter: 'all' as const
    };
};

export const extractCostEstimateData = (
    markdown: string
): CostEstimateData | null => {
    try {
        // Try directive syntax first: ::costEstimate{data="..."}
        const directiveMatch = /::costEstimate\s*\{[^}]*data="([^"]+)"[^}]*\}/.exec(markdown);
        if (directiveMatch) {
            const encodedData = directiveMatch[1];
            const decodedData = decodeURIComponent(escape(atob(encodedData)));
            return JSON.parse(decodedData) as CostEstimateData;
        }

        // Fall back to JSX syntax: <CostEstimate data="..." />
        const jsxMatch = /<CostEstimate\s+data="([^"]+)"\s*\/>/.exec(markdown);
        if (jsxMatch) {
            const encodedData = jsxMatch[1];
            const decodedData = decodeURIComponent(escape(atob(encodedData)));
            return JSON.parse(decodedData) as CostEstimateData;
        }
        return null;
    } catch (error) {
        console.warn('Failed to extract cost estimate data:', error);
        return null;
    }
};
